import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

interface BookingItem {
  id?: number;
  accommodation: string;
  product: string;
  startDate: string;
  endDate: string;
  numberOfPeople: number;
  grossPricePerPersonPerNight: number;
  retailPrice: number;
}

interface BookingVersion {
  versionNumber: number;
  isCurrent: boolean;
  createdAt: number;
  updatedAt: number;
  items: BookingItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingVersionHistory',
  props: {
    versions: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

// ---------- Sort newest first ----------
const sortedVersions = computed(() =>
  props.versions
    .filter((version) => !version.isCurrent)
    .sort((a, b) => b.versionNumber - a.versionNumber)
);

// ---------- Table headers ----------
const itemHeaders = [
  { title: "Szállás", key: "accommodation" },
  { title: "Termék", key: "product" },
  { title: "Érkezés", key: "startDate" },
  { title: "Távozás", key: "endDate" },
  { title: "Létszám", key: "numberOfPeople", align: "end" },
  {
    title: "Bekerülési ár /fő/éj",
    key: "grossPricePerPersonPerNight",
    align: "end",
  },
  { title: "Kiajánlott ár /fő/éj", key: "retailPrice", align: "end" },
];

// ---------- Formatters ----------
const formatDateTime = (timestamp?: number) => {
  if (!timestamp) return "-";
  return new Date(timestamp).toLocaleString("hu-HU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatPrice = (value?: number) => {
  if (!value) return "-";
  return `${value.toLocaleString("hu-HU")} Ft`;
};

const __returned__ = { props, sortedVersions, itemHeaders, formatDateTime, formatPrice, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})